import { render, staticRenderFns } from "./TicketDeVenta.vue?vue&type=template&id=21fcfc74&scoped=true"
import script from "./TicketDeVenta.vue?vue&type=script&lang=js"
export * from "./TicketDeVenta.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/ticketVenta.css?vue&type=style&index=0&id=21fcfc74&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fcfc74",
  null
  
)

export default component.exports